import { h, PropType, defineComponent } from 'vue';
import { coming_soon } from '@components/icons';
import { toggle_grid } from '../../scene';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import toggle_grid_svg from '../../../assets/img/SVG_icons/Bottom/visualisation/toggle_grid.svg';
import { img } from '@phi/components';
import ToggleGridTooltip from './ToggleGridTooltip';
import { ISubscriptions } from '@phi/subscriptions/frontend';

export const ToggleGridIcon = toggle_grid_svg;

export default defineComponent({
    props: {
        state: {
            required: true,
            type: Object as PropType<State>,
        },
        subscriptions: { required: true, type: Object as PropType<ISubscriptions> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Show/hide grid';
        },

        disabled() {
            return !this.state.loaded;
        },
    },

    watch: {
        disabled(value: boolean) {
            this.$emit('update:disabled', value);
        },
    },

    emits: {
        'update:disabled': (x: boolean) => true,
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else if (this.subscriptions.state.subscription_status.value === 'starter')
                this.subscriptions.show_pro_feature_modal();
            else
                toggle_grid();
        },
    },

    render() {
        return h(BarButton, {
            id: 'toggle-grid-button',
            tippy: 'right',
            disabled: this.disabled,
            selected: this.state.tut_stage === 3,
            active: this.state.grid_visible,
            help: 'grid',
            onClick: this.onClick,
            pro_indicator: this.subscriptions.state.subscription_status.value === 'starter',
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(toggle_grid_svg, this.alt),
            tooltip: ToggleGridTooltip,
        });
    },
});
